import { UsersRound, User } from 'lucide-react'
import { supabase } from '@/integrations/supabase/client'

const TAG_COLORS: Record<string, string> = {
  binome: 'bg-orange-100 text-orange-700 border-orange-200',
  solo: 'bg-purple-100 text-purple-700 border-purple-200',
}
const TAG_HOVER: Record<string, string> = {
  binome: 'hover:bg-orange-200',
  solo: 'hover:bg-purple-200',
}
const TAG_DEFAULT_COLOR = 'bg-gray-100 text-gray-600 border-gray-200'

export const displayTag = (tag: string) => tag === 'binome' ? 'binôme' : tag

export const TagIcon = ({ tag, size = 11, className = '' }: { tag: string; size?: number; className?: string }) => {
  if (tag === 'binome') return <UsersRound size={size} className={className} />
  if (tag === 'solo') return <User size={size} className={className} />
  return null
}

export const tagActiveClass = (tag: string) =>
  `${TAG_COLORS[tag] || TAG_DEFAULT_COLOR} ${TAG_HOVER[tag] || 'hover:bg-gray-200'}`

export const TagBadge = ({ tag }: { tag: string }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${TAG_COLORS[tag] || TAG_DEFAULT_COLOR}`}>
    {displayTag(tag)}
  </span>
)

const EXCLUSIVE_TAGS = ['binome', 'solo']

export const computeNewTags = (currentTags: string[], tag: string): string[] => {
  if (currentTags.includes(tag)) return currentTags.filter(t => t !== tag)
  return [...currentTags.filter(t => !(EXCLUSIVE_TAGS.includes(t) && EXCLUSIVE_TAGS.includes(tag))), tag]
}

export const toggleTagInDB = async (beneficiaryId: string, tag: string, currentTags: string[]): Promise<string[]> => {
  const newTags = computeNewTags(currentTags, tag)
  await supabase.from('beneficiaries').update({ tags: newTags }).eq('id', beneficiaryId)
  return newTags
}
